module.exports = __webpack_public_path__ + "img/783-0f9057.png";